import { render, staticRenderFns } from "./MonitorView.vue?vue&type=template&id=2767494b&scoped=true&"
import script from "./MonitorView.vue?vue&type=script&lang=js&"
export * from "./MonitorView.vue?vue&type=script&lang=js&"
import style0 from "./MonitorView.vue?vue&type=style&index=0&id=2767494b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767494b",
  null
  
)

export default component.exports